import { Module } from 'vuex'

interface JudgeDetailPageState {
  isHideJudgeCaseList: boolean[]
}

export const judgeDetailPageStateModule = (): Module<JudgeDetailPageState, any> => {
  return {
    namespaced: true,
    state: {
      isHideJudgeCaseList: []
    },
    mutations: {
      setIsHideJudgeCaseList(state, { isHideJudgeCaseList }: { isHideJudgeCaseList: boolean[] }) {
        state.isHideJudgeCaseList = isHideJudgeCaseList
      },
      setFlagIsHideJudgeCaseList(state, { index, flag }: { index: number; flag: boolean }) {
        state.isHideJudgeCaseList[index] = flag
      }
    },
    actions: {},
    getters: {
      isHideJudgeCaseList: state => state.isHideJudgeCaseList
    }
  }
}
